import { render } from "./SideBarPage.vue?vue&type=template&id=f7e3ec8c&scoped=true"
import script from "./SideBarPage.vue?vue&type=script&lang=js"
export * from "./SideBarPage.vue?vue&type=script&lang=js"

import "./SideBarPage.vue?vue&type=style&index=0&id=f7e3ec8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7e3ec8c"]])

export default __exports__